/**
 * Footer Memerle — accordéons fermés sur mobile, ouverts sur desktop.
 */
(function () {
  const MOBILE_QUERY = '(max-width: 989px)';

  function syncFooterAccordions() {
    const isMobile = window.matchMedia(MOBILE_QUERY).matches;
    document.querySelectorAll('.memerle-footer-editorial__accordion').forEach((details) => {
      if (isMobile) {
        details.removeAttribute('open');
      } else {
        details.setAttribute('open', '');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFooterAccordions);
  } else {
    syncFooterAccordions();
  }

  window.matchMedia(MOBILE_QUERY).addEventListener('change', syncFooterAccordions);
})();
